import { RemoteGetAllEntities } from 'data/usecases';
import { makeApiUrlEntities } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeRemoteGetAllEntities = (): RemoteGetAllEntities => {
  return new RemoteGetAllEntities(makeApiUrlEntities(), makeAxiosHttpClient());
};
